module.exports = __webpack_public_path__ + "static/media/1.cd8baa95.JPG";